import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="container-fluid py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center py-5">
              <div className="display-1 fw-bold text-muted mb-3">404</div>
              <h4 className="fw-bold">Page Not Found</h4>
              <p className="text-muted mb-4">
                The page you're looking for doesn't exist or has been moved.
              </p>
              <div className="d-flex gap-2 justify-content-center">
                <Link to="/trust-tech-studio" className="btn btn-primary">
                  <i className="bi bi-house me-1"></i>Go to Dashboard
                </Link>
                <button className="btn btn-outline-secondary" onClick={() => window.history.back()}>
                  <i className="bi bi-arrow-left me-1"></i>Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
